import React, { useState, useEffect, useCallback } from 'react';
import { apiFetch } from './utils/api';
import SubscribersTab from './components/admin/SubscribersTab';
import TemplatesTab from './components/admin/TemplatesTab';
import ComposeTab from './components/admin/ComposeTab';
import LogsTab from './components/admin/LogsTab';
import './EmailServiceManager.css';

const TABS = [
  { key: 'subscribers', labelEn: 'Subscribers', labelKo: '구독자' },
  { key: 'templates', labelEn: 'Templates', labelKo: '템플릿' },
  { key: 'compose', labelEn: 'Compose Newsletter', labelKo: '뉴스레터 작성' },
  { key: 'logs', labelEn: 'Email Logs', labelKo: '발송 로그' },
];

export default function EmailServiceManager() {
  const [activeTab, setActiveTab] = useState('subscribers');
  const [stats, setStats] = useState(null);

  const loadStats = useCallback(async () => {
    try {
      const res = await apiFetch('/api/v1/admin/email-logs/stats');
      if (res.ok) setStats(await res.json());
    } catch { /* ignore */ }
  }, []);

  useEffect(() => { loadStats(); }, [loadStats]);

  return (
    <div className="em-page">
      <div className="em-header">
        <h1>Email Service Manager</h1>
      </div>

      {/* Stats Cards */}
      <div className="em-stats">
        <div className="em-stat-card">
          <span className="em-stat-value">{stats?.total_sent ?? '—'}</span>
          <span className="em-stat-label">Total Sent</span>
        </div>
        <div className="em-stat-card em-stat-delivered">
          <span className="em-stat-value">{stats?.delivered ?? '—'}</span>
          <span className="em-stat-label">Delivered</span>
        </div>
        <div className="em-stat-card em-stat-bounced">
          <span className="em-stat-value">{stats?.bounced ?? '—'}</span>
          <span className="em-stat-label">Bounced</span>
        </div>
        <div className="em-stat-card em-stat-complaints">
          <span className="em-stat-value">{stats?.complaints ?? '—'}</span>
          <span className="em-stat-label">Complaints</span>
        </div>
        <div className="em-stat-card">
          <span className="em-stat-value">{stats?.sent_today ?? '—'}</span>
          <span className="em-stat-label">Today</span>
        </div>
        <div className="em-stat-card">
          <span className="em-stat-value">{stats?.sent_this_week ?? '—'}</span>
          <span className="em-stat-label">This Week</span>
        </div>
      </div>

      {/* Tab Bar */}
      <div className="em-tabs">
        {TABS.map(tab => (
          <button
            key={tab.key}
            className={`em-tab ${activeTab === tab.key ? 'em-tab-active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.labelEn}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="em-content">
        {activeTab === 'subscribers' && <SubscribersTab />}
        {activeTab === 'templates' && <TemplatesTab />}
        {activeTab === 'compose' && <ComposeTab />}
        {activeTab === 'logs' && <LogsTab onStatsChange={loadStats} />}
      </div>
    </div>
  );
}
